/* eslint-disable react/require-default-props */
import { DatePicker } from 'antd';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

/**
 * Wrapper sobre el componente DatePicker de antd que trabaja con fechas en formato string
 * DatePicker trabaja con la libreria momentjs, para ver los formatos de fecha aceptadso ver https://momentjscom.readthedocs.io/en/latest/moment/01-parsing/03-string-format/
 *
 */
const StrDatePicker = ({ value, onChange, dateFormat, style, ...restOfProps }) => {
  const [internalValue, setInternalValue] = useState(value ? moment(value, dateFormat) : undefined);

  useEffect(() => {
    const newValue = value ? moment(value, dateFormat) : undefined;
    setInternalValue(newValue);
  }, [value]);

  const onInternalValueChange = (momentValue) => {
    const strDate = momentValue.format(dateFormat);
    setInternalValue(momentValue);
    onChange(strDate);
  };

  const updatedStyle = {
    ...style,
    width: '100%',
  };

  return (
    <DatePicker
      value={internalValue}
      style={updatedStyle}
      onChange={onInternalValueChange}
      {...restOfProps}
    />
  );
};

StrDatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  dateFormat: PropTypes.string,
  style: PropTypes.shape(),
};

StrDatePicker.defaultProps = {
  value: undefined,
  onChange: undefined,
  dateFormat: undefined,
};

export default StrDatePicker;
